import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { value: '*' }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "codemirror-wrapper" }
const _hoisted_10 = { class: "box" }
const _hoisted_11 = { class: "subtitle" }
const _hoisted_12 = { class: "fermi-json-editor" }
const _hoisted_13 = {
  class: "modal-card",
  style: {"width":"600px","max-width":"95vw"}
}
const _hoisted_14 = { class: "modal-card-head" }
const _hoisted_15 = { class: "modal-card-title" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "modal-card-body" }
const _hoisted_18 = { class: "modal-card-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_BFieldHint = _resolveComponent("BFieldHint")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_b_switch = _resolveComponent("b-switch")!
  const _component_b_taginput = _resolveComponent("b-taginput")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_codemirror = _resolveComponent("codemirror")!
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_JsonEditorVue = _resolveComponent("JsonEditorVue")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_SecretForm = _resolveComponent("SecretForm")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_tabs, {
      modelValue: _ctx.activeMainTab,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeMainTab) = $event)),
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_tab_item, {
          label: _ctx.$t('integrations.lambdaBuilder'),
          value: 'form'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('integrations.lambdaIntegration')), 1),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.name'),
                hintKey: _ctx.$t('integrations.nameHelp')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_input, {
                    ref: "nameInput",
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    placeholder: _ctx.$t('integrations.namePlaceholder'),
                    required: "",
                    maxlength: "64",
                    pattern: "[a-Z/_0-9]*",
                    "validation-message": _ctx.$t('integrations.nameValidationError')
                  }, null, 8, ["modelValue", "placeholder", "validation-message"])
                ]),
                _: 1
              }, 8, ["label", "hintKey"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.device'),
                hintKey: "integrations.deviceHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_select, {
                    modelValue: _ctx.form.deviceId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.deviceId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('integrations.anyDevice')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (d) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: d.id,
                          value: d.id
                        }, _toDisplayString(d.name || d.id), 9, _hoisted_4))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.status'),
                hintKey: "integrations.statusHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_switch, {
                    modelValue: _ctx.form.enabled,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.enabled) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.enabled ? (_ctx.$t('integrations.enabled')) : (_ctx.$t('integrations.disabled'))), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('global.secrets'),
                hintKey: "integrations.secretsHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_taginput, {
                    modelValue: _ctx.selectedSecrets,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSecrets) = $event)),
                    data: _ctx.filteredSecretOptions,
                    autocomplete: "",
                    "open-on-focus": true,
                    "allow-new": false,
                    placeholder: _ctx.$t('secrets.selectSecretsPlaceholder'),
                    type: "is-primary",
                    onTyping: _ctx.onSecretTyping
                  }, null, 8, ["modelValue", "data", "placeholder", "onTyping"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                      type: "is-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.secretModalOpen = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('secrets.addNewButton')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.form.parameters && _ctx.form.parameters.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('integrations.parameters')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.parameters, (param, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "columns is-mobile",
                        key: param.template_name || idx
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_b_field, {
                            label: param.template_name || ('Param ' + (idx + 1))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_input, {
                                modelValue: param.value,
                                "onUpdate:modelValue": ($event: any) => ((param.value) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.language'),
                hintKey: "integrations.languageHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_select, {
                    modelValue: _ctx.form.language,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.language) = $event))
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("option", { value: "javascript" }, "JavaScript", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.code'),
                hintKey: "integrations.codeHelp"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_codemirror, {
                      modelValue: _ctx.form.code,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.code) = $event)),
                      style: { height: '520px', width: '100%' },
                      "indent-with-tab": true,
                      "tab-size": 2,
                      extensions: _ctx.cmExtensions
                    }, null, 8, ["modelValue", "extensions"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_b_tab_item, {
          label: _ctx.$t('integrations.jsonTemplate'),
          value: 'json'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('integrations.integrationJsonRepresentation')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_JsonEditorVue, {
                  modelValue: _ctx.integrationInitial,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.integrationInitial) = $event)),
                  mode: _ctx.jsonEditorMode,
                  stringified: false,
                  "main-menu-bar": false,
                  "navigation-bar": false,
                  "status-bar": false,
                  style: {"height":"520px"}
                }, null, 8, ["modelValue", "mode"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.secretModalOpen,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.secretModalOpen) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": false,
      "aria-role": "dialog",
      "can-cancel": ['escape','x','outside'],
      "aria-label": "Add Secret",
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("header", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('secrets.addNew')), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: props.close
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("section", _hoisted_17, [
            _createVNode(_component_SecretForm, {
              rows: 4,
              ref: "secretFormInModal",
              onSaved: _ctx.handleSecretCreated,
              onValid: _cache[9] || (_cache[9] = v => (_ctx.canSaveSecret = v))
            }, null, 8, ["onSaved"])
          ]),
          _createElementVNode("footer", _hoisted_18, [
            _createVNode(_component_b_button, {
              type: "is-primary",
              disabled: !_ctx.canSaveSecret,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.secretFormInModal?.submit?.()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_b_button, {
              onClick: props.close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.close')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _ctx.save,
        loading: _ctx.saving,
        disabled: !_ctx.isValid
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading", "disabled"]),
      _createVNode(_component_b_button, {
        class: "ml-2",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.back()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}